import React, { useEffect } from "react";
import AOS from 'aos';
import 'aos/dist/aos.css';

const Card = ({ title, value, color, icon: Icon }) => {
    useEffect(() => {
        AOS.init({
            duration: 1000, // Animation duration in milliseconds
            once: true, // Whether animation should happen only once
        });
    }, []);

    return (
        <div data-aos="fade-up" data-aos-delay="100" className="bg-white p-6 rounded-lg shadow-lg hover:shadow-2xl transition-shadow">
            <div className="flex items-center mb-4">
                {/* Render the passed icon */}
                <Icon className="h-6 w-6 text-gray-500 mr-2" />
                <h3 className="text-lg font-bold text-gray-700">{title}</h3>
            </div>
            <p className={`mt-2 text-3xl font-semibold ${color}`}>{value}</p>
        </div>
    );
};

export default Card;
